import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-79e638d0")

_pushScopeId("data-v-79e638d0")
const _hoisted_1 = { class: "flex" }
const _hoisted_2 = { class: "flex-grow flex flex-col justify-between h-screen" }
const _hoisted_3 = { class: "flex-grow flex relative z-0 bg-primary-100 overflow-hidden lg:overscroll-auto" }
const _hoisted_4 = { class: "flex-1 flex flex-col h-full bg-white rounded-t-md mx-1 max-width-dynamic" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_MNavBar = _resolveComponent("MNavBar")
  const _component_MHeaderPanel = _resolveComponent("MHeaderPanel")
  const _component_MSMessagePanel = _resolveComponent("MSMessagePanel")
  const _component_MSProfilePanel = _resolveComponent("MSProfilePanel")
  const _component_MSHistoryPanel = _resolveComponent("MSHistoryPanel")
  const _component_MSBadgePanel = _resolveComponent("MSBadgePanel")
  const _component_MSLearningPanel = _resolveComponent("MSLearningPanel")
  const _component_MSSubmissionsPanel = _resolveComponent("MSSubmissionsPanel")
  const _component_MSTodoPanel = _resolveComponent("MSTodoPanel")
  const _component_MSReflectionPanel = _resolveComponent("MSReflectionPanel")
  const _component_m_s_edit_modal = _resolveComponent("m-s-edit-modal")
  const _component_m_s_todo_add_modal = _resolveComponent("m-s-todo-add-modal")
  const _component_m_s_todo_edit_modal = _resolveComponent("m-s-todo-edit-modal")
  const _component_ms_reserve_modal = _resolveComponent("ms-reserve-modal")
  const _component_ms_comment_modal = _resolveComponent("ms-comment-modal")
  const _component_ms_add_property_modal = _resolveComponent("ms-add-property-modal")
  const _component_ms_edit_property_modal = _resolveComponent("ms-edit-property-modal")
  const _component_m_s_add_reflection_modal = _resolveComponent("m-s-add-reflection-modal")
  const _component_m_s_edit_reflection_modal = _resolveComponent("m-s-edit-reflection-modal")
  const _component_m_s_display_reflection_modal = _resolveComponent("m-s-display-reflection-modal")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_MNavBar),
      _createVNode("div", _hoisted_2, [
        _createVNode(_component_MHeaderPanel, {
          title: _ctx.studentName,
          breadcrumbs: _ctx.breadcrumbs
        }, null, 8, ["title", "breadcrumbs"]),
        _createVNode("main", _hoisted_3, [
          _createVNode(_component_MSMessagePanel, {
            student: _ctx.student,
            "in-recess": _ctx.inRecess,
            class: "flex-1 mx-1 lg:mx-0 w-panel max-width-dynamic"
          }, null, 8, ["student", "in-recess"]),
          _createVNode("div", _hoisted_4, [
            (_ctx.student && _ctx.pageType == 'profile')
              ? (_openBlock(), _createBlock(_component_MSProfilePanel, {
                  key: 0,
                  student: _ctx.student,
                  school: _ctx.school,
                  "school-config": _ctx.schoolConfig,
                  classroom: _ctx.classroom,
                  "custom-properties": _ctx.customProperties,
                  role: _ctx.role,
                  onOpen: _ctx.openModal,
                  onOpenComment: _ctx.openCommentModal,
                  onOpenReserve: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isDisplayReserveModal = true)),
                  onOpenAddProperty: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isDisplayAddPropertyModal = true)),
                  onOpenEditProperty: _ctx.openEditPropertyModal
                }, null, 8, ["student", "school", "school-config", "classroom", "custom-properties", "role", "onOpen", "onOpenComment", "onOpenEditProperty"]))
              : (
              _ctx.student && _ctx.pageType == 'history' && !_ctx.isExclusiveSchoolAiUser
            )
                ? (_openBlock(), _createBlock(_component_MSHistoryPanel, {
                    key: 1,
                    student: _ctx.student,
                    onOpen: _ctx.openModal
                  }, null, 8, ["student", "onOpen"]))
                : (
              _ctx.student && _ctx.pageType == 'badge' && !_ctx.isExclusiveSchoolAiUser
            )
                  ? (_openBlock(), _createBlock(_component_MSBadgePanel, {
                      key: 2,
                      student: _ctx.student,
                      onOpen: _ctx.openModal
                    }, null, 8, ["student", "onOpen"]))
                  : (_ctx.pageType == 'learning' && !_ctx.isExclusiveSchoolAiUser)
                    ? (_openBlock(), _createBlock(_component_MSLearningPanel, {
                        key: 3,
                        student: _ctx.student,
                        onOpen: _ctx.openModal
                      }, null, 8, ["student", "onOpen"]))
                    : (
              _ctx.student && _ctx.pageType == 'submissions' && !_ctx.isExclusiveSchoolAiUser
            )
                      ? (_openBlock(), _createBlock(_component_MSSubmissionsPanel, {
                          key: 4,
                          student: _ctx.student,
                          onOpen: _ctx.openModal
                        }, null, 8, ["student", "onOpen"]))
                      : (_ctx.student && _ctx.pageType == 'todo')
                        ? (_openBlock(), _createBlock(_component_MSTodoPanel, {
                            key: 5,
                            student: _ctx.student,
                            onOpenTodoAddModal: _ctx.openTodoAddModal,
                            onSelect: _ctx.editTodo
                          }, null, 8, ["student", "onOpenTodoAddModal", "onSelect"]))
                        : (
              _ctx.student && _ctx.pageType == 'reflection' && _ctx.canUseLearningCard
            )
                          ? (_openBlock(), _createBlock(_component_MSReflectionPanel, {
                              key: 6,
                              student: _ctx.student,
                              onOpenReflectionAddModal: _ctx.openReflectionAddModal,
                              onSelect: _ctx.selectReflection
                            }, null, 8, ["student", "onOpenReflectionAddModal", "onSelect"]))
                          : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    (_ctx.isDisplayStudentEditModal && _ctx.student)
      ? (_openBlock(), _createBlock(_component_m_s_edit_modal, {
          key: 0,
          student: _ctx.student,
          role: _ctx.role,
          classrooms: _ctx.classrooms,
          "custom-properties": _ctx.customProperties,
          "school-id": _ctx.schoolId,
          onClose: _ctx.closeStudentEditModal
        }, null, 8, ["student", "role", "classrooms", "custom-properties", "school-id", "onClose"]))
      : _createCommentVNode("", true),
    (_ctx.isDisplayTodoAddModal && _ctx.student)
      ? (_openBlock(), _createBlock(_component_m_s_todo_add_modal, {
          key: 1,
          student: _ctx.student,
          onClose: _ctx.closeTodoAddModal
        }, null, 8, ["student", "onClose"]))
      : _createCommentVNode("", true),
    (_ctx.isDisplayTodoEditModal && _ctx.student)
      ? (_openBlock(), _createBlock(_component_m_s_todo_edit_modal, {
          key: 2,
          student: _ctx.student,
          todo: _ctx.todoToEdit,
          onClose: _ctx.closeTodoEditModal
        }, null, 8, ["student", "todo", "onClose"]))
      : _createCommentVNode("", true),
    (_ctx.isDisplayReserveModal && _ctx.student)
      ? (_openBlock(), _createBlock(_component_ms_reserve_modal, {
          key: 3,
          "default-student-ids": [_ctx.student.ref.id],
          onClose: _cache[3] || (_cache[3] = ($event: any) => (_ctx.isDisplayReserveModal = false))
        }, null, 8, ["default-student-ids"]))
      : _createCommentVNode("", true),
    (_ctx.isDisplayCommentModal && _ctx.student)
      ? (_openBlock(), _createBlock(_component_ms_comment_modal, {
          key: 4,
          student: _ctx.student,
          comment: _ctx.comment,
          onClose: _cache[4] || (_cache[4] = ($event: any) => (_ctx.isDisplayCommentModal = false))
        }, null, 8, ["student", "comment"]))
      : _createCommentVNode("", true),
    (_ctx.isDisplayAddPropertyModal && _ctx.school)
      ? (_openBlock(), _createBlock(_component_ms_add_property_modal, {
          key: 5,
          school: _ctx.school,
          "custom-properties": _ctx.customProperties,
          onClose: _cache[5] || (_cache[5] = ($event: any) => (_ctx.isDisplayAddPropertyModal = false))
        }, null, 8, ["school", "custom-properties"]))
      : _createCommentVNode("", true),
    (_ctx.isDisplayEditPropertyModal && _ctx.school && _ctx.selectedCustomProperty)
      ? (_openBlock(), _createBlock(_component_ms_edit_property_modal, {
          key: 6,
          school: _ctx.school,
          "custom-property": _ctx.selectedCustomProperty,
          "custom-properties": _ctx.customProperties,
          onClose: _cache[6] || (_cache[6] = ($event: any) => (_ctx.isDisplayEditPropertyModal = false))
        }, null, 8, ["school", "custom-property", "custom-properties"]))
      : _createCommentVNode("", true),
    (_ctx.isDisplayReflectionAddModal && _ctx.school)
      ? (_openBlock(), _createBlock(_component_m_s_add_reflection_modal, {
          key: 7,
          student: _ctx.student,
          onClose: _cache[7] || (_cache[7] = ($event: any) => (_ctx.isDisplayReflectionAddModal = false))
        }, null, 8, ["student"]))
      : _createCommentVNode("", true),
    (_ctx.isDisplayReflectionEditModal && _ctx.school)
      ? (_openBlock(), _createBlock(_component_m_s_edit_reflection_modal, {
          key: 8,
          student: _ctx.student,
          unit: _ctx.selectedUnit,
          onClose: _cache[8] || (_cache[8] = 
      () => {
        _ctx.isDisplayReflectionEditModal = false;
        _ctx.selectedUnit = null;
      }
    )
        }, null, 8, ["student", "unit"]))
      : _createCommentVNode("", true),
    (_ctx.isDisplayReflectionDisplayModal && _ctx.school)
      ? (_openBlock(), _createBlock(_component_m_s_display_reflection_modal, {
          key: 9,
          student: _ctx.student,
          unit: _ctx.selectedUnit,
          "can-edit": _ctx.canEditStudent,
          onClose: _cache[9] || (_cache[9] = 
      () => {
        _ctx.isDisplayReflectionDisplayModal = false;
        _ctx.selectedUnit = null;
      }
    )
        }, null, 8, ["student", "unit", "can-edit"]))
      : _createCommentVNode("", true)
  ], 64))
})